
import { z } from "zod";

export const EscrowHistoryFieldValues = ["status", "externalId", "vendor", "contractAmount", "fundedAmount", "pendingAmount", "disbursedAmount", "fullyFundedDate", "fullyDisbursedDate", "cancellationFee", "fundingMilestoneSchedule", "customerInviteLink", "requestForQuoteId", "deletedAt"] as const;
export const EscrowHistoryFieldSchema = z.enum(EscrowHistoryFieldValues);
export const EscrowHistoryField = EscrowHistoryFieldSchema.enum;
export type EscrowHistoryField = (typeof EscrowHistoryFieldValues)[number];
